<template>
    <div class="agents-on-map">       
        <!-- Карта всегда видима -->
        <div class="map-container">
            <div id="map" style="height: 600px; width: 100%;"></div>
            
            <!-- Полупрозрачный блок загрузки поверх карты -->
            <div v-if="loading || !mapInitialized" class="map-loading-overlay">
                <div class="loading-content">
                    <div v-if="loading" class="text-center">
                        <b-spinner variant="primary" label="Загрузка..."></b-spinner>
                        <p class="mt-2 mb-0">Загружаем данные о компаниях...</p>
                    </div>
                    <div v-else class="text-center">
                        <b-spinner variant="info" label="Инициализация..."></b-spinner>
                        <p class="mt-2 mb-0">Инициализация карты...</p>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Легенда и статистика всегда видны -->
        <div class="map-legend mt-3">
            <h6>Легенда:</h6>
            <div class="d-flex flex-wrap">
                <div class="legend-item mr-4 mb-2">
                    <span class="legend-color approved"></span>
                    <span>Подписан договор оферты</span>
                </div>
                <div class="legend-item mr-4 mb-2">
                    <span class="legend-color pending"></span>
                    <span>На проверке</span>
                </div>
                <div class="legend-item mr-4 mb-2">
                    <span class="legend-color revision"></span>
                    <span>На доработке</span>
                </div>
                <div class="legend-item mr-4 mb-2">
                    <span class="legend-color rejected"></span>
                    <span>Отклонён</span>
                </div>
                <div class="legend-item mr-4 mb-2">
                    <span class="legend-color fill"></span>
                    <span>На заполнении</span>
                </div>
            </div>
        </div>
<!--         
        <div class="map-stats mt-3">
            <div class="row">
                <div class="col-md-3">
                    <div class="stat-card">
                        <div class="stat-number">{{ totalCompanies }}</div>
                        <div class="stat-label">Всего компаний</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="stat-card">
                        <div class="stat-number">{{ totalRegions }}</div>
                        <div class="stat-label">Регионов</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="stat-card">
                        <div class="stat-number">{{ approvedCompanies }}</div>
                        <div class="stat-label">Одобрено</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="stat-card">
                        <div class="stat-number">{{ pendingCompanies }}</div>
                        <div class="stat-label">На проверке</div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { API_AGENT_COMPANY, API_REGIONS } from '@/constants/api'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
    name: 'AgentsOnMap',
    data() {
        return {
            map: null,
            companies: [],
            regions: {},
            markers: [],
            loading: false,
            mapInitialized: false,
            regionCoordinates: {}
        }
    },
    computed: {
        totalCompanies() {
            return this.companies.length
        },
        totalRegions() {
            return Object.keys(this.regions).length
        },
        approvedCompanies() {
            return this.companies.filter(c => c.check_status === 'approved').length
        },
        pendingCompanies() {
            return this.companies.filter(c => c.check_status === 'pending').length
        }
    },
    async mounted() {
        console.log('Компонент AgentsOnMap mounted')
        
        // Сначала загружаем все данные
        await this.loadRegions()
        await this.loadCompanies()
        
        // Ждем полного рендера компонента
        await this.$nextTick()
        
        // Инициализируем карту
        this.initMap()
    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove()
        }
    },
    methods: {
        async loadRegions() {
            try {
                const response = await api.call('get', API_REGIONS)
                const regionsData = response.data.data || response.data || []
                
                // Создаем карту координат регионов
                regionsData.forEach(region => {
                    if (region.id) {
                        this.regionCoordinates[region.id] = this.getRegionCoordinates(region)
                    }
                })
            } catch (error) {
                console.error('Ошибка загрузки регионов:', error)
            }
        },
        
        async loadCompanies() {
            try {
                this.loading = true
                
                // Получаем все агентские компании
                const response = await api.call('get', API_AGENT_COMPANY + '?per_page=1000')
                this.companies = response.data.data || []
                
                // Группируем компании по регионам
                this.groupCompaniesByRegions()
                
            } catch (error) {
                console.error('Ошибка загрузки компаний:', error)
                this.$bvToast.toast('Ошибка загрузки данных', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true
                })
            } finally {
                this.loading = false
            }
        },
        
        groupCompaniesByRegions() {
            this.regions = {}
            
            this.companies.forEach(company => {
                if (company.region_id && company.region) {
                    if (!this.regions[company.region_id]) {
                        this.regions[company.region_id] = {
                            id: company.region_id,
                            name: company.region.name,
                            fullname: company.region.fullname,
                            companies: [],
                            coordinates: this.regionCoordinates[company.region_id] || this.getDefaultCoordinates(company.region_id)
                        }
                    }
                    this.regions[company.region_id].companies.push(company)
                }
            })
        },
        
        getRegionCoordinates(region) {
            // Пытаемся получить координаты из данных региона
            if (region.latitude && region.longitude) {
                return [parseFloat(region.latitude), parseFloat(region.longitude)]
            }
            
            // Если координат нет, используем координаты столицы региона
            if (region.capital_latitude && region.capital_longitude) {
                return [parseFloat(region.capital_latitude), parseFloat(region.capital_longitude)]
            }
            
            return null
        },
        
        getDefaultCoordinates(regionId) {
            // Координаты центров регионов России согласно актуальному списку
            const defaultCoordinates = {
                1: [44.6098, 40.1005],    // Адыгея
                2: [54.7387, 55.9721],    // Башкортостан
                3: [53.0375, 107.5841],   // Бурятия
                4: [51.9584, 85.9603],    // Алтай
                5: [43.1617, 46.5885],    // Дагестан
                6: [43.1682, 44.8121],    // Ингушетия
                7: [43.5855, 43.4089],    // Кабардино-Балкарская
                8: [46.5717, 45.3227],    // Калмыкия
                9: [43.7730, 41.9168],    // Карачаево-Черкесская
                10: [61.7840, 34.3709],   // Карелия
                11: [67.1530, 64.2553],   // Коми
                12: [56.6384, 47.8907],   // Марий Эл
                13: [54.1838, 45.1749],   // Мордовия
                14: [62.0355, 129.6755],  // Саха /Якутия/
                15: [43.1151, 44.7231],   // Северная Осетия - Алания
                16: [55.7887, 49.1221],   // Татарстан
                17: [51.7191, 94.4377],   // Тыва
                18: [57.1914, 53.2048],   // Удмуртская
                19: [53.7156, 91.4292],   // Хакасия
                20: [43.3178, 45.6947],   // Чеченская
                21: [56.8519, 60.6122],   // Чувашская
                22: [53.3548, 83.7698],   // Алтайский
                23: [45.0448, 38.9760],   // Краснодарский
                24: [56.0184, 92.8672],   // Красноярский
                25: [43.1198, 131.8869],  // Приморский
                26: [45.0445, 41.9697],   // Ставропольский
                27: [48.4827, 135.0840],  // Хабаровский
                28: [50.2901, 127.5402],  // Амурская
                29: [64.5473, 40.5433],   // Архангельская
                30: [46.3589, 48.0586],   // Астраханская
                31: [50.5977, 36.5858],   // Белгородская
                32: [53.2521, 34.3717],   // Брянская
                33: [56.1446, 40.4170],   // Владимирская
                34: [51.6720, 39.1843],   // Воронежская
                35: [59.2239, 39.8839],   // Вологодская
                36: [48.7071, 44.5169],   // Волгоградская
                37: [57.7665, 40.9269],   // Ивановская
                38: [52.2864, 104.3050],  // Иркутская
                39: [54.7065, 20.5112],   // Калининградская
                40: [54.5293, 36.2754],   // Калужская
                41: [53.0370, 158.6559],  // Камчатский
                42: [55.3904, 86.0466],   // Кемеровская
                43: [58.6031, 49.6653],   // Кировская
                44: [57.7665, 40.9269],   // Костромская
                45: [55.4584, 65.3142],   // Курганская
                46: [51.7373, 36.1873],   // Курская
                47: [52.6031, 39.5704],   // Липецкая
                48: [59.5683, 150.8085],  // Магаданская
                49: [68.9792, 33.0925],   // Мурманская
                50: [56.2965, 43.9361],   // Нижегородская
                51: [58.5213, 31.2755],   // Новгородская
                52: [55.0084, 82.9357],   // Новосибирская
                53: [54.9914, 73.3646],   // Омская
                54: [51.7727, 55.0988],   // Оренбургская
                55: [52.9703, 36.0631],   // Орловская
                56: [53.2007, 45.0046],   // Пензенская
                57: [58.0105, 56.2502],   // Пермский
                58: [57.8136, 28.3496],   // Псковская
                59: [47.2357, 39.7015],   // Ростовская
                60: [54.6269, 39.6916],   // Рязанская
                61: [54.1961, 45.1749],   // Самарская
                62: [51.5924, 46.0343],   // Саратовская
                63: [46.9641, 142.7380],  // Сахалинская
                64: [56.8431, 60.6454],   // Свердловская
                65: [54.7818, 32.0401],   // Смоленская
                66: [56.8587, 35.9006],   // Тверская
                67: [54.1961, 37.6182],   // Тульская
                68: [56.4977, 84.9744],   // Томская
                69: [54.1961, 37.6182],   // Ульяновская
                70: [57.1522, 65.5272],   // Тюменская
                71: [54.1961, 37.6182],   // Ульяновская
                72: [55.1544, 61.4297],   // Челябинская
                73: [51.8335, 113.5341],  // Забайкальский
                74: [57.6261, 39.8875],   // Ярославская
                75: [55.7558, 37.6176],   // Москва и область (центр Москвы)
                76: [59.9311, 30.3609],   // Санкт-Петербург и область (центр СПб)
                77: [48.4827, 135.0840],  // Еврейская
                78: [61.0042, 69.8523],   // Ханты-Мансийский
                79: [66.5494, 66.6083],   // Ненецкий
                80: [66.3200, -179.1000], // Чукотский
                81: [66.5494, 66.6083]    // Ямало-Ненецкий
            }
            
            return defaultCoordinates[regionId] || [65.0, 105.0] // Центр России по умолчанию
        },
        
        async initMap() {
            try {
                console.log('Инициализация карты Leaflet...')
                
                // Инициализация карты Leaflet
                this.map = L.map('map').setView([65.0, 105.0], 3)
                
                // Добавляем базовый слой OpenStreetMap
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap contributors'
                }).addTo(this.map)
                
                // Добавляем маркеры на карту
                this.addMarkersToMap()
                
                this.mapInitialized = true
                console.log('Карта успешно инициализирована')
                
                // Скрываем блок атрибуции Leaflet
                this.hideLeafletAttribution()
                
            } catch (error) {
                console.error('Ошибка инициализации карты:', error)
                // Показываем ошибку в overlay
                this.$bvToast.toast('Ошибка инициализации карты', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true
                })
            }
        },
        
        addMarkersToMap() {
            if (!this.map) return
            
            // Очищаем существующие маркеры
            this.markers.forEach(marker => this.map.removeLayer(marker))
            this.markers = []
            
            Object.values(this.regions).forEach(region => {
                if (region.coordinates && region.companies.length > 0) {
                    const marker = this.createRegionMarker(region)
                    this.markers.push(marker)
                    marker.addTo(this.map)
                }
            })
        },
        
        createRegionMarker(region) {
            const statusCounts = this.getStatusCounts(region.companies)
            const totalCompanies = region.companies.length
            
            // Создаем HTML для попапа
            const popupContent = this.createPopupContent(region, statusCounts, totalCompanies)
            
            // Создаем градиентный маркер с цифрами внутри
            const marker = this.createGradientMarker(region.coordinates, statusCounts, totalCompanies)
            
            // Добавляем попап
            marker.bindPopup(popupContent, {
                maxWidth: 400,
                maxHeight: 300
            })
            
            return marker
        },
        
        getStatusCounts(companies) {
            const counts = {
                approved: 0,
                pending: 0,
                revision: 0,
                rejected: 0,
                fill: 0
            }
            
            companies.forEach(company => {
                if (counts.hasOwnProperty(company.check_status)) {
                    counts[company.check_status]++
                }
            })
            
            return counts
        },
        
        getDominantStatus(statusCounts) {
            let maxCount = 0
            let dominantStatus = 'fill'
            
            Object.entries(statusCounts).forEach(([status, count]) => {
                if (count > maxCount) {
                    maxCount = count
                    dominantStatus = status
                }
            })
            
            return dominantStatus
        },
        
        getStatusColor(status) {
            const colors = {
                approved: '#28a745',      // Зеленый
                pending: '#ffc107',       // Желтый
                revision: '#fd7e14',      // Оранжевый
                rejected: '#dc3545',      // Красный
                fill: '#6c757d'           // Серый
            }
            
            return colors[status] || colors.fill
        },
        
        createPopupContent(region, statusCounts, totalCompanies) {
            const statusLabels = {
                approved: 'Подписан договор оферты',
                pending: 'На проверке',
                revision: 'На доработке',
                rejected: 'Отклонён',
                fill: 'На заполнении'
            }
            
            let content = `
                <div class="region-popup">
                    <h6><strong>${region.fullname}</strong></h6>
                    <p class="mb-2">Всего компаний: <strong>${totalCompanies}</strong></p>
                    <div class="status-breakdown">
            `
            
            Object.entries(statusCounts).forEach(([status, count]) => {
                if (count > 0) {
                    const color = this.getStatusColor(status)
                    const label = statusLabels[status]
                    content += `
                        <div class="status-item">
                            <span class="status-dot" style="background-color: ${color}"></span>
                            <span>${label}: ${count}</span>
                        </div>
                    `
                }
            })
            
            content += `
                    </div>
                    <div class="mt-2">
                        <small class="text-muted">Нажмите для просмотра деталей</small>
                    </div>
                </div>
            `
            
            return content
        },
        
        createGradientMarker(coordinates, statusCounts, totalCompanies) {
            const radius = Math.max(15, Math.min(30, totalCompanies * 2))
            
            // Создаем SVG для градиентного кружка
            const svg = this.createGradientSVG(statusCounts, radius)
            
            // Создаем divIcon с SVG
            const icon = L.divIcon({
                className: 'gradient-marker',
                html: svg,
                iconSize: [radius * 2, radius * 2],
                iconAnchor: [radius, radius]
            })
            
            // Создаем маркер
            const marker = L.marker(coordinates, {
                icon: icon,
                interactive: true
            })
            
            return marker
        },
        
        createGradientSVG(statusCounts, radius) {
            const total = Object.values(statusCounts).reduce((sum, count) => sum + count, 0)
            if (total === 0) return ''
            
            let currentAngle = 0
            const svgParts = []
            
            // Создаем секторы для каждого статуса
            Object.entries(statusCounts).forEach(([status, count]) => {
                if (count > 0) {
                    const percentage = count / total
                    const angle = percentage * 360
                    const color = this.getStatusColor(status)
                    
                    if (percentage === 1) {
                        // Если только один статус, создаем полный круг
                        svgParts.push(`
                            <circle cx="${radius}" cy="${radius}" r="${radius}" 
                                    fill="${color}" stroke="#fff" stroke-width="2"/>
                        `)
                    } else if (angle > 0) {
                        // Создаем сектор
                        const x1 = radius + radius * Math.cos(currentAngle * Math.PI / 180)
                        const y1 = radius + radius * Math.sin(currentAngle * Math.PI / 180)
                        const x2 = radius + radius * Math.cos((currentAngle + angle) * Math.PI / 180)
                        const y2 = radius + radius * Math.sin((currentAngle + angle) * Math.PI / 180)
                        
                        const largeArcFlag = angle > 180 ? 1 : 0
                        
                        svgParts.push(`
                            <path d="M ${radius} ${radius} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z" 
                                  fill="${color}" stroke="#fff" stroke-width="1"/>
                        `)
                        
                        currentAngle += angle
                    }
                }
            })
            
            // Добавляем цифру в центр
            const fontSize = Math.max(10, Math.min(16, radius * 0.6))
            svgParts.push(`
                <text x="${radius}" y="${radius + fontSize * 0.35}" 
                      text-anchor="middle" 
                      font-family="Arial, sans-serif" 
                      font-size="${fontSize}" 
                      font-weight="900" 
                      fill="white" 
                      stroke="black" 
                      stroke-width="0.5" 
                      stroke-linejoin="round">
                    ${total}
                </text>
            `)
            
            return `
                <svg width="${radius * 2}" height="${radius * 2}" viewBox="0 0 ${radius * 2} ${radius * 2}">
                    ${svgParts.join('')}
                </svg>
            `
        },
        
        hideLeafletAttribution() {
            // Ждем немного для полного рендера карты
            setTimeout(() => {
                const attributionElement = document.querySelector('.leaflet-bottom .leaflet-control-attribution')
                if (attributionElement) {
                    attributionElement.style.display = 'none'
                }
            }, 10)
        }
    }
}
</script>

<style scoped>
.agents-on-map {
    padding: 0px;
}

.map-container {
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    position: relative;
}

.map-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(2px);
}

.loading-content {
    background: rgba(255, 255, 255, 0.95);
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.loading-content p {
    color: #6c757d;
    font-weight: 500;
}



.map-legend {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #dee2e6;
}

.legend-item {
    display: flex;
    align-items: center;
}

.legend-color {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 8px;
    border: 2px solid #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.legend-color.approved { background-color: #28a745; }
.legend-color.pending { background-color: #ffc107; }
.legend-color.revision { background-color: #fd7e14; }
.legend-color.rejected { background-color: #dc3545; }
.legend-color.fill { background-color: #6c757d; }

.map-stats {
    margin-top: 20px;
}

.stat-card {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.stat-number {
    font-size: 2rem;
    font-weight: bold;
    color: #007bff;
    margin-bottom: 5px;
}

.stat-label {
    color: #6c757d;
    font-size: 0.9rem;
}

/* Стили для попапа */
.region-popup {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.status-breakdown {
    margin-top: 10px;
}

.status-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.status-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 8px;
    flex-shrink: 0;
}

/* Стили для градиентных маркеров */
.gradient-marker {
    background: transparent !important;
    border: none !important;
}

.gradient-marker svg {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}


</style>
